import { render, staticRenderFns } from "./ColorManipulation.vue?vue&type=template&id=5b81d09f&scoped=true&"
import script from "./ColorManipulation.vue?vue&type=script&lang=js&"
export * from "./ColorManipulation.vue?vue&type=script&lang=js&"
import style0 from "./ColorManipulation.vue?vue&type=style&index=0&id=5b81d09f&prod&scoped=true&lang=css&"
import style1 from "./ColorManipulation.vue?vue&type=style&index=1&id=5b81d09f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81d09f",
  null
  
)

export default component.exports